import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ReplacementProductList from "./list/ReplacementProductList";
import { ButtonToolbar, notifyToast, ToastType } from "../../../components";
import { saveConsumableProduct } from "../api-handler/api-handler";
import { DisplaySpinnerContext, RouteGuardContext, TabPanelContext } from "../../../context/ContextIndex";
import { selectSessionConfig } from "../../../store/store-selector";
import ReplacementProductCreate from "./create/ReplacementProductCreate";
import { setBackDropLoader } from "../../../components-old/ComponentsIndex";

const ReplacementProductView = () => {
  const navigate = useNavigate();
  const _tabContextObject = useContext(TabPanelContext);
  const routeGuardContext = useContext(RouteGuardContext);
  const _tabContext = _tabContextObject.getTabFormContext();
  const editConsumableProductId = _tabContext.editConsumableProductId;

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const [showForm, setShowForm] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const replacementProducts = _tabContext.data?.replacementProducts ? _tabContext.data?.replacementProducts.length : 0;

  const handleAddClick = () => {
    setShowForm(true);
  };

  //on cancel of create replacement product form
  const handleCancelForm = () => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedReplacementProduct: null,
      },
    });
    setShowForm(false);
  };

  const onCancel = () => {
    try {
      navigate("/consumableproductlist");
    } catch (err) {
      alert(err);
    }
  };

  //on submit of consumable product group
  const onSubmit = async () => {
    try {
      spinnerCtx.setLoadingIndicator(true);
      routeGuardContext.setFormState(false);
      const status = await saveConsumableProduct(_tabContext.data, {
        editConsumableProductId,
        settingsConfig,
        formdata: _tabContext.prevData,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for approval", ToastType.SUCCESS);
        onCancel();
      } else {
        notifyToast(status.erroMessage ? status.erroMessage
          : "Consumable product creation failed", ToastType.ERROR);
      }
    } catch (err) {
      alert(err);
    } finally {
      spinnerCtx.setLoadingIndicator(false);
    }
  };

  //on submit of replacement product form
  const handleFormSubmit = () => {
    setShowForm(false);
  };

  useEffect(() => {
    routeGuardContext.setFormState(_tabContext?.isDirty);
    setIsFormValid(_tabContext?.isDirty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  return (
    <>
      {!showForm ? (
        <>
          {setBackDropLoader(spinnerCtx.isLoading)}
          <ReplacementProductList onAddClick={handleAddClick} setShowForm={setShowForm} setIsFormValid={setIsFormValid} />
          <ButtonToolbar
            onCancel={onCancel}
            onSubmit={onSubmit}
            isFormValid={replacementProducts > 0 && isFormValid ? true : false}
            isWithAppForm={false}
          />
        </>
      ) : (
        <ReplacementProductCreate onSubmit={handleFormSubmit} onCancel={handleCancelForm} />
      )}
    </>
  );
};

export default ReplacementProductView;
